import React from 'react'
import { ButtonReg } from 'atoms/Buttons'
import lo from 'lodash'

export const statusBtnFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { transparent, theme, width, height, field, type, auto } = formatExtraData
  let btnColor;
  let val;

  switch (type) {
    case 'Daily Report':
      if (row[field]) {
        val = 'Blasted'
        btnColor = theme.mocaGreen
      } else {
        val = 'Unblasted'
        btnColor = theme.mocaRed
      }
      break;
    case 'Data Validation':
      const rowField = lo.startCase(row[field])
      switch (rowField) {
        case 'Not Uploaded':
        case 'Not Validated':
          btnColor = theme.mocaRed
          break;
        case 'Partially Uploaded':
        case 'Partially Validated':
          btnColor = theme.mocaOrange
          break;
        default:
          btnColor = theme.mocaGreen
          break;
      }
      val = rowField
      break;
    case 'Blasting Report':
      switch (row[field]) {
        case 'APPROVED':
          btnColor = theme.mocaGreen
          break;
        case 'SENDBACK':
          btnColor = theme.mocaRed
          break;
        case 'SUBMITTED':
          btnColor = theme.mocaOrange
          break;
        default:
          btnColor = theme.mocaGreen
          break;
      }
      val = row[field]
      break;  
    default:
      switch (row[field]) {
        case false:
          btnColor = theme.mocaRed
          break;
        case 'HIGH':
          btnColor = theme.mocaRed
          break;
        case 'MEDIUM':
          btnColor = theme.mocaOrange
          break;
        default:
          btnColor = theme.mocaGreen
          break;
      }
      switch (row[field]) {
        case true:
          val = 'CLOSED'
          break;
        case false:
          val = 'OPEN'
          break;
        default:
          val = row[field]
          break;
      }
  }

  return (
    <div>
      <ButtonReg
        width={`${auto ? 'auto' : width ? width + 'px' : '52px'}`}
        height={`${auto ? 'auto' : height ? height + 'px' : '25px'}`}
        minHeight={`${auto ? '25px' : '0px'}`}
        size={'12px'}
        bg={btnColor}
        color={transparent ? btnColor : theme.white}
        transparent={transparent}
        bordered={transparent}
        btnTxt={val}
        noclick={true}
      />
    </div>
  )
}
